export function parseTrackingUrlResponse(response: unknown): string | null {
  if (!response) return null;
  if (typeof response === "string") {
    const trimmed = response.trim();
    return trimmed || null;
  }

  if (typeof response !== "object") return null;

  const payload = response as Record<string, unknown>;
  const nested = payload.data;
  const candidates = [
    payload.url,
    payload.tracking_url,
    payload.trackingUrl,
    typeof nested === "object" && nested != null ? (nested as Record<string, unknown>).url : null,
    typeof nested === "object" && nested != null ? (nested as Record<string, unknown>).tracking_url : null,
  ];

  for (const candidate of candidates) {
    if (typeof candidate === "string" && candidate.trim()) {
      return candidate.trim();
    }
  }

  return null;
}
